import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

export class ErrorMessageUtil {

  static getErrorMessage(formGroup: FormGroup, translateService: TranslateService, fieldName: string, divisor?: number): string {
    if(!formGroup)
      return ''
    if (formGroup.controls[fieldName].hasError('required')) {
      return translateService.instant('FormErrorMessage.FieldValueRequired')
    }
    if (formGroup.controls[fieldName].hasError('email')) {
      return translateService.instant('FormErrorMessage.EmailFieldEmailFormatError')
    }
    if (formGroup.controls[fieldName].hasError('divisor') && divisor) {
      return translateService.instant('FormErrorMessage.DivisorError') + divisor;
    }
    if (formGroup.controls[fieldName].hasError('maxlength')) {
      const maxCharacters = formGroup.controls[fieldName].errors?.['maxlength']?.requiredLength;
      return `Máximo ${maxCharacters} caracteres permitidos.`;
    }
    if (formGroup.controls[fieldName].hasError('minlength')) {
      const minCharacters = formGroup.controls[fieldName].errors?.['minlength']?.requiredLength;
      return `Mínimo ${minCharacters} caracteres requeridos.`;
    }
    if (formGroup.controls[fieldName].hasError('passwordStrength')) {
      return translateService.instant('FormErrorMessage.StrongPasswordError')
    }
    return '';
  }

  static getResponseError(error: any, lang?: string, defaultMessage: string = ""): string {
    switch(lang) {
      case 'en':
        return error.messageEn ?? defaultMessage
      case 'es':
        return error.messageEs ?? defaultMessage
      default:
        return defaultMessage
    }
  }

  static msgResponseError(error: any, defaultMessage: string = ""): string {
    return error?.data?.description ?? defaultMessage
  }
}
